/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkshopPhase', 'model/WorkshopPhaseReport', 'model/FileTransferHelperEntity'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/WorkshopPhase'), require('../model/WorkshopPhaseReport'), require('../model/FileTransferHelperEntity'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopPhaseApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkshopPhase, root.ForStractionServiceApi.WorkshopPhaseReport, root.ForStractionServiceApi.FileTransferHelperEntity);
  }
}(this, function(ApiClient, WorkshopPhase, WorkshopPhaseReport, FileTransferHelperEntity) {
  'use strict';

  /**
   * WorkshopPhase service.
   * @module api/WorkshopPhaseApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new WorkshopPhaseApi. 
   * @alias module:api/WorkshopPhaseApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the workshopPhaseAddPut operation.
     * @callback module:api/WorkshopPhaseApi~workshopPhaseAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkshopPhase} body 
     * @param {module:api/WorkshopPhaseApi~workshopPhaseAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.workshopPhaseAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopPhaseAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/WorkshopPhase/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseChangePhasePublicationStatusGet operation.
     * @callback module:api/WorkshopPhaseApi~workshopPhaseChangePhasePublicationStatusGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopPhaseReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * changePhasePublicationStatus
     * @param {String} _4SAPIAppID 
     * @param {Integer} phaseID 
     * @param {Boolean} published 
     * @param {module:api/WorkshopPhaseApi~workshopPhaseChangePhasePublicationStatusGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopPhaseReport}
     */
    this.workshopPhaseChangePhasePublicationStatusGet = function(_4SAPIAppID, phaseID, published, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseChangePhasePublicationStatusGet";
      }

      // verify the required parameter 'phaseID' is set
      if (phaseID == undefined || phaseID == null) {
        throw "Missing the required parameter 'phaseID' when calling workshopPhaseChangePhasePublicationStatusGet";
      }

      // verify the required parameter 'published' is set
      if (published == undefined || published == null) {
        throw "Missing the required parameter 'published' when calling workshopPhaseChangePhasePublicationStatusGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'phaseID': phaseID,
        'published': published
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopPhaseReport;

      return this.apiClient.callApi(
        '/WorkshopPhase/changePhasePublicationStatus', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseCloneGet operation.
     * @callback module:api/WorkshopPhaseApi~workshopPhaseCloneGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/WorkshopPhaseReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clone
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopPhaseApi~workshopPhaseCloneGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/WorkshopPhaseReport>}
     */
    this.workshopPhaseCloneGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseCloneGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopPhaseCloneGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [WorkshopPhaseReport];

      return this.apiClient.callApi(
        '/WorkshopPhase/clone', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseDeleteGet operation.
     * @callback module:api/WorkshopPhaseApi~workshopPhaseDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopPhaseApi~workshopPhaseDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopPhaseDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopPhaseDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopPhase/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseEditAllPut operation.
     * @callback module:api/WorkshopPhaseApi~workshopPhaseEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/WorkshopPhase>} body 
     * @param {module:api/WorkshopPhaseApi~workshopPhaseEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopPhaseEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopPhaseEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopPhase/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseEditPut operation.
     * @callback module:api/WorkshopPhaseApi~workshopPhaseEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkshopPhase} body 
     * @param {module:api/WorkshopPhaseApi~workshopPhaseEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopPhaseEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopPhaseEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopPhase/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseLoadGet operation.
     * @callback module:api/WorkshopPhaseApi~workshopPhaseLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopPhaseReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopPhaseApi~workshopPhaseLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopPhaseReport}
     */
    this.workshopPhaseLoadGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopPhaseLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopPhaseReport;

      return this.apiClient.callApi(
        '/WorkshopPhase/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseLoadWorkshopPhasesGet operation.
     * @callback module:api/WorkshopPhaseApi~workshopPhaseLoadWorkshopPhasesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/WorkshopPhaseReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadWorkshopPhases
     * @param {String} _4SAPIAppID 
     * @param {Integer} workshopID 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.translate  (default to false)
     * @param {module:api/WorkshopPhaseApi~workshopPhaseLoadWorkshopPhasesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/WorkshopPhaseReport>}
     */
    this.workshopPhaseLoadWorkshopPhasesGet = function(_4SAPIAppID, workshopID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseLoadWorkshopPhasesGet";
      }

      // verify the required parameter 'workshopID' is set
      if (workshopID == undefined || workshopID == null) {
        throw "Missing the required parameter 'workshopID' when calling workshopPhaseLoadWorkshopPhasesGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'workshopID': workshopID,
        'translate': opts['translate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [WorkshopPhaseReport];

      return this.apiClient.callApi(
        '/WorkshopPhase/loadWorkshopPhases', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseStoreCustomBackgroundImagePut operation.
     * @callback module:api/WorkshopPhaseApi~workshopPhaseStoreCustomBackgroundImagePutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * storeCustomBackgroundImage
     * @param {String} _4SAPIAppID 
     * @param {module:model/FileTransferHelperEntity} body 
     * @param {Integer} phaseID 
     * @param {module:api/WorkshopPhaseApi~workshopPhaseStoreCustomBackgroundImagePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.workshopPhaseStoreCustomBackgroundImagePut = function(_4SAPIAppID, body, phaseID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseStoreCustomBackgroundImagePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopPhaseStoreCustomBackgroundImagePut";
      }

      // verify the required parameter 'phaseID' is set
      if (phaseID == undefined || phaseID == null) {
        throw "Missing the required parameter 'phaseID' when calling workshopPhaseStoreCustomBackgroundImagePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'phaseID': phaseID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/WorkshopPhase/storeCustomBackgroundImage', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
